// Wrapper page for the gear-menu "Privacy Policy" entry.
// Embedded mode (no modal close button) inside the standard page chrome.

import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import PrivacyView from "./PrivacyView";

export default function PrivacyPage() {
    const { h, t, go, role } = useContext(Ctx);
    return (
        <div style={{ paddingTop: 16 }}>
            <button
                onClick={() => go(role === "landlord" ? "settings" : "dash")}
                style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>
                &larr; {t.back || "Back"}
            </button>
            <PrivacyView embedded />
        </div>
    );
}
